export default __webpack_public_path__ + "static/media/BM_RenderCamera_08_BedroomA+Interior+Light_Scheme+Bedroom.e38f3294.jpg";